export default class Modal {
    constructor() {
        this._eventBind();
    }

    _eventBind() {
        const $openbtns = [...document.querySelectorAll('.js-modal_open')];
        const $closebtns = [...document.querySelectorAll('.js-modal_close')];
        const $ph = document.querySelector('.js-modal_ph');

        for (const $openbtn of $openbtns) {
            $openbtn.addEventListener('click', (e) => {
                e.preventDefault();

                const { modalid } = $openbtn.dataset;
                const $target = document.querySelector(`.js-modal[data-modalid="${modalid}"]`);

                if (modalid === 'kv') {
                    $ph.innerHTML = $openbtn.innerHTML;
                }

                $target && $target.classList.add('-active');
                document.body.classList.add('-lock');
            });
        }

        for (const $closebtn of $closebtns) {
            $closebtn.addEventListener('click', () => {
                const $target = $closebtn.closest('.js-modal');

                $target && $target.classList.remove('-active');
                document.body.classList.remove('-lock');
            });
        }
    }
}
